import {FormControl} from '@angular/forms';

export const VeeMeteringPointFormGroup = {
  meteringPointType: new FormControl(),
  meteringPointIdentification: new FormControl(),
  streetName: new FormControl(),
  streetNumber: new FormControl(),
  postalCode: new FormControl<string | null>(null),
}
